







import ApiClient from '@/js/api.js'
import TextBox from '@/views/atoms/TextBox.vue'
import NormalButton from '@/views/atoms/NormalButton.vue'

export default
  name: 'Zipcode'

  components: {
    TextBox
    NormalButton
  }

  props:
    value:
      type: String
      default: ''

  methods: {
    search_address: (e) ->
      api = new ApiClient()
      data = await api.post('/tool/zipcode')
      @.$emit('search_address', data)
  }
